var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageUrl)?_c('img',{staticClass:"img-fluid d-block",attrs:{"src":_vm.imageUrl,"alt":_vm.event.header}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }